import React from 'react'
import styles from './EESupplementalSubComp.module.scss'

interface Props {
  benefitAmount: string | JSX.Element[] | JSX.Element | undefined
  benefitAmount2?: string | undefined
  name: string
  amountLabel: string
  noDollarSign?: boolean
}

const BenefitComp: React.FC<Props> = ({ benefitAmount, benefitAmount2, name, amountLabel, noDollarSign }) => {
  return (
    <div className={styles.accident_deathBenefit}>
      <div className={styles.accidental_death_benefit_Heading}>
        {name && <p className={styles.benefitBoxTitle}>{name}</p>}
        <div className={styles.accidental_death_price}>
          {benefitAmount && benefitAmount2 ? <> { !noDollarSign && <span className={styles.dolar}>$</span>}<span className={styles.amount}>{benefitAmount} to</span> { !noDollarSign && <span className={styles.dolar}>$</span>}<span className={styles.amount}>{benefitAmount2}</span> </> : <> { !noDollarSign && <span className={styles.dolar}>$</span>}<span className={styles.amount}>{benefitAmount}</span> </>}
          {amountLabel && <p className= {styles.benefit_amount_label}> {amountLabel} </p>}
        </div>
      </div>
    </div>
  )
}

export default BenefitComp
